export default __webpack_public_path__ + "static/media/legazpi.f6e74689.jpg";